import { render } from "./SelectRolesPage.vue?vue&type=template&id=32da1923"
import script from "./SelectRolesPage.vue?vue&type=script&lang=js"
export * from "./SelectRolesPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SelectRolesPage.vue?vue&type=style&index=0&id=32da1923&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__